import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, BookOpen } from "lucide-react";
import { SEO } from "../components/SEO";
import { GUIDES } from "../data/guides";

export default function GuidesIndex() {
  return (
    <>
      <SEO title="AI Writing & Prompt Engineering Guides" description="Step-by-step tutorials and strategy guides for AI writing tools: prompt engineering, editing AI output, email sequences, content calendars, and more." />
      <section className="pt-36 pb-20 px-6 lg:px-10">
        <div className="max-w-6xl mx-auto">
          <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="font-mono-tag text-xs uppercase tracking-[0.2em] text-gold mb-4">Guides</motion.p>
          <motion.h1 initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} className="font-display font-black text-4xl sm:text-5xl text-white tracking-tight max-w-2xl">Tutorials & Strategy, Not Just Reviews</motion.h1>
          <p className="text-zinc-400 mt-4 max-w-xl">Step-by-step frameworks, real case studies, and hands-on tests — everything we learned building this comparison.</p>

          <div className="grid sm:grid-cols-2 gap-5 mt-14">
            {GUIDES.map((g, i) => (
              <motion.div key={g.slug} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-60px" }} transition={{ duration: 0.5, delay: (i % 2) * 0.08 }}>
                <Link to={`/guides/${g.slug}`} className="group flex gap-4 items-start border border-white/10 rounded-sm p-5 hover:border-primary/50 transition-colors bg-surface/40 h-full">
                  <img src={g.heroImage} alt={g.title} className="w-20 h-20 object-cover rounded-sm grayscale group-hover:grayscale-0 transition-all duration-500 shrink-0" />
                  <div>
                    <BookOpen className="w-4 h-4 text-gold mb-2" aria-hidden="true" />
                    <h3 className="text-white font-display font-bold text-base leading-snug">{g.title}</h3>
                    <p className="text-primary text-sm font-medium mt-2 inline-flex items-center gap-1 group-hover:gap-2 transition-all">Read guide <ArrowRight className="w-3.5 h-3.5" aria-hidden="true" /></p>
                  </div>
                </Link>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
